export const ATTORNEYS_POWERS_DEFAULT = 'MINTRUD_MIN01';

const DEFAULT_MAX_FILE_SIZE_MB = 20;

export const MAX_FILE_SIZE_MB =
  Number(window.REACT_APP_VKHRTEK_FILE_UPLOAD_MAX_SIZE_MB) ||
  DEFAULT_MAX_FILE_SIZE_MB;

const UNEP_KONTUR_CONFIRMATION_CODE_LENGTH: Record<string, number> = {
  sms: 6,
  call: 4,
};

const UNEP_KONTUR_DEFAULT_CONFIRMATION_TYPE = 'sms';

const UNEP_KONTUR_CONFIRMATION_TYPE =
  window.REACT_APP_VKHRTEK_UNEP_KONTUR_CONFIRMATION_TYPE ||
  UNEP_KONTUR_DEFAULT_CONFIRMATION_TYPE;

export const UNEP_KONTUR_CODE_LENGTH =
  UNEP_KONTUR_CONFIRMATION_CODE_LENGTH[UNEP_KONTUR_CONFIRMATION_TYPE];

const RELOAD_ERROR_CODES = ['sign_type_changed'];

export const isReloadError = (errorCode?: string) => {
  return RELOAD_ERROR_CODES.includes(errorCode || '');
};

export const KONTUR_RECOVERY_DEFAULT_MESSAGE =
  'Уже ведутся работы по восстановлению';

export const REGEXP_EXTERNAL_URL = /^https?:\/\//i;
